import { render, staticRenderFns } from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=template&id=db4188e8&scoped=true"
import script from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoRigheEditComponentN.vue?vue&type=style&index=0&id=db4188e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4188e8",
  null
  
)

export default component.exports